import { utils } from '@yola/ws-color-rules';

const PALETTE_LOOKUP_ORDER = [
  'light',
  'altLight',
  'dark',
  'altDark',
  'primary',
  'secondary',
  'error',
  'info',
  'success',
  'warning',
];

const initAssignVariable = (config) => (targetColor) => {
  const { cssVariablesMap, palettes, whiteColor, blackColor } = config;
  if (targetColor.strictlyEquals(blackColor, false)) {
    return `var(${cssVariablesMap.black})`;
  }

  if (targetColor.strictlyEquals(whiteColor, false)) {
    return `var(${cssVariablesMap.white})`;
  }

  let shade;
  const mapKey = PALETTE_LOOKUP_ORDER.find((colorName) => {
    shade = utils.findColorShadeInPalette(targetColor, palettes[`${colorName}Palette`], false);
    return shade;
  });

  if (shade) {
    return `var(${cssVariablesMap[mapKey][shade]})`;
  }

  return targetColor.toColorString();
};

export default initAssignVariable;
